import * as React from 'react';
import DateTime from 'react-datetime';
import { connect } from 'react-redux';
import { Button, FormGroup, FormControl, ControlLabel, Row, Col, Panel } from 'react-bootstrap';
import { Translate } from '../../shared/LanguageService';
import Marker from '../map/shapes/Marker';
import { Map } from '../map/Map';
import FormSelect from '../../components/common/FormSelect';
import Polygon from '../map/shapes/Polygon';
import Circle from '../map/shapes/Circle';
import * as Actions from './actions/PhotographerOverviewActions';
import { getSiteName } from '../../shared/Site';
import * as Site from '../../shared/Site';
import moment from 'moment';

interface IPhotographerOverviewActions {
    getPhotographerOverview: (
        year: any,
        month: any,
        day: any,
        streetAddress: any,
        postalCode: any,
        city: any,
        userSite: number
    ) => any;
}

interface IPhotographerOverviewProps {
    actions: IPhotographerOverviewActions;
    mapSettings: any[];
    products: any[];
    customers: any[];
    streetCoordinate: any;
    googleMapsApiError: string;
    site: string;
}

class PhotographerOverviewComponent extends React.Component<IPhotographerOverviewProps, any> {
    constructor(props: IPhotographerOverviewProps, context: any) {
        super(props, context);

        this.state = {
            mapSettings: [],
            filteredMapSettings: [],
            highlightedPhotographer: -1,
            selectedDate: moment(),
            streetAddress: '',
            postalCode: '',
            selectedProductId: -1,
            selectedBrokerFirmId: -1,
            city: '',
            selectedUserSite: 1 /* SE360 */
        };
    }

    UNSAFE_componentWillMount() {
        this.getPhotographerOverview();
    }

    UNSAFE_componentWillReceiveProps(nextProps: IPhotographerOverviewProps) {
        if (nextProps.mapSettings) {
            let highlightedPhotographer = this.state.highlightedPhotographer;
            setTimeout(() => {
                let mapSettings = nextProps.mapSettings.map((map) => {
                    let markerVisible = highlightedPhotographer === map.photographerId;
                    let settings: any = {
                        center: map.marker.center,
                        circle: new Circle(
                            map.circle.center,
                            map.circle.radius,
                            false,
                            false,
                            true,
                            () => {}
                        ),
                        polygon: new Polygon(map.polygon.path, false, false, true, () => {}),
                        marker: new Marker(map.marker.center, false, false, () => {}),
                        photographerName: map.photographerName,
                        photographerId: map.photographerId,
                        products: map.products,
                        brokerFirmBlockings: map.brokerFirmBlockings,
                        selectable: true,
                        isPhotographer: true,
                        productId: -1,
                        brokerFirmId: -1,
                        searchParams: ''
                    };
                    if (nextProps.streetCoordinate) {
                        settings.polygon.hideIfIntersects(nextProps.streetCoordinate);
                        settings.circle.hideIfIntersects(nextProps.streetCoordinate);
                        settings.selectable = settings.circle.Visible && settings.polygon.Visible;
                    }
                    settings.marker.Visible = settings.selectable && markerVisible;
                    return settings;
                });

                if (nextProps.streetCoordinate) {
                    let coordinate = nextProps.streetCoordinate;
                    let streetMapSettings = {
                        center: coordinate,
                        circle: new Circle(coordinate, 0, false, false, false, () => {}),
                        polygon: new Polygon(null, false, false, false, () => {}),
                        marker: new Marker(coordinate, false, true, () => {}),
                        isPhotographer: false
                    };

                    mapSettings.push(streetMapSettings);
                }

                this.setState({
                    mapSettings: mapSettings
                });
            }, 100);
        }
    }

    highlightPhotographer(photographerId: number) {
        let mapSettings = this.state.mapSettings;

        for (let i = 0; i < mapSettings.length; i++) {
            if (mapSettings[i].isPhotographer) {
                mapSettings[i].marker.Visible = false;
                if (mapSettings[i].photographerId === photographerId) {
                    mapSettings[i].marker.Visible = true;
                }
            }
        }

        this.setState({
            ...this.state,
            mapSettings: mapSettings,
            highlightedPhotographer: photographerId
        });
    }

    filterFunc(x: any) {
        if (!x.isPhotographer) return true;
        let visible = true;
        let selectedProductId = Number(this.state.productId);
        let selectedBrokerFirmId = Number(this.state.brokerFirmId);

        if (selectedProductId >= 0 && selectedBrokerFirmId >= 0) {
            return (
                x.products.hasOwnProperty(selectedProductId) &&
                !x.brokerFirmBlockings.hasOwnProperty(selectedBrokerFirmId)
            );
        } else if (selectedProductId >= 0 && selectedBrokerFirmId === -1) {
            return x.products.hasOwnProperty(selectedProductId);
        } else if (selectedBrokerFirmId >= 0 && selectedProductId === -1) {
            return !x.brokerFirmBlockings.hasOwnProperty(selectedBrokerFirmId);
        }
        return visible;
    }

    getPhotographerOverview() {
        let searchParams = `${this.state.selectedDate.year()}${
            this.state.selectedDate.month() + 1
        }${this.state.selectedDate.date()}${this.state.streetAddress}${this.state.postalCode}${
            this.state.city
        }`;
        let previousSearchParams = this.state.searchParams;

        if (searchParams !== previousSearchParams) {
            this.props.actions
                .getPhotographerOverview(
                    this.state.selectedDate.year(),
                    this.state.selectedDate.month() +
                        1 /* months are zero indexed, hence the incrementation */,
                    this.state.selectedDate.date(),
                    this.state.streetAddress,
                    this.state.postalCode,
                    this.state.city,
                    this.state.selectedUserSite
                )
                .then(() => {
                    this.filterPhotographers();
                });
        } else {
            this.filterPhotographers();
        }
    }

    filterPhotographers() {
        let selectedBrokerFirmId = this.state.selectedBrokerFirmId;
        let selectedProductId = this.state.selectedProductId;

        this.setState({
            brokerFirmId: selectedBrokerFirmId,
            productId: selectedProductId
        });
    }

    updateValue(key: string, evt: any) {
        let state = this.state;
        if (!state.hasOwnProperty(key)) return;
        state[key] = evt.target.value;

        this.setState(state);
    }

    getMapCenter() {
        if (this.state.highlightedPhotographer > 0) {
            return this.state.mapSettings.find(
                (map) => map.photographerId === this.state.highlightedPhotographer
            ).center;
        }
        return this.state.mapSettings[0].center;
    }

    render() {
        return (
            <div>
                <Row>
                    <Col md={3}>
                        <fieldset>
                            <FormGroup>
                                <ControlLabel>
                                    {Translate('photographers/overview/label/user-site')}
                                </ControlLabel>
                                <FormSelect
                                    name="userSite"
                                    value={this.state.selectedUserSite}
                                    onChange={(evt: any) => {
                                        this.setState({
                                            selectedUserSite: evt.target.value
                                        });
                                    }}
                                >
                                    {this.props.site === getSiteName(Site.Zentuvo) ?
                                        <option value="1">
                                            {Translate('photographers/overview/label/user-site/se360')}
                                        </option>
                                    :    
                                        <>
                                            <option value="1">
                                                {Translate('photographers/overview/label/user-site/se360')}
                                            </option>
                                            <option value="2">
                                                {Translate(
                                                    'photographers/overview/label/user-site/scandphotos'
                                                )}
                                            </option>
                                        </>
                                    }
                                </FormSelect>
                            </FormGroup>
                            <FormGroup>
                                <ControlLabel>
                                    {Translate('photographers/overview/label/date')}
                                </ControlLabel>
                                <DateTime
                                    locale={moment.locale()}
                                    input={true}
                                    onChange={(value) => {
                                        this.setState({ selectedDate: value });
                                    }}
                                    timeFormat={false}
                                    value={this.state.selectedDate}
                                    isValidDate={(date) => {
                                        return date.isAfter(moment().subtract(1, 'day'));
                                    }}
                                    closeOnSelect={true}
                                />
                            </FormGroup>
                        </fieldset>

                        <fieldset>
                            <FormGroup>
                                <ControlLabel>
                                    {Translate('photographers/overview/label/streetaddress')}
                                </ControlLabel>
                                <FormControl
                                    autoFocus
                                    type="text"
                                    name="name"
                                    required
                                    value={this.state.streetAddress}
                                    onChange={(evt) => {
                                        this.updateValue('streetAddress', evt);
                                    }}
                                />
                            </FormGroup>
                            <FormGroup>
                                <ControlLabel>
                                    {Translate('photographers/overview/label/postalcode')}
                                </ControlLabel>
                                <FormControl
                                    autoFocus
                                    type="text"
                                    name="name"
                                    required
                                    value={this.state.postalCode}
                                    onChange={(evt) => {
                                        this.updateValue('postalCode', evt);
                                    }}
                                />
                            </FormGroup>
                            <FormGroup>
                                <ControlLabel>
                                    {Translate('photographers/overview/label/city')}
                                </ControlLabel>
                                <FormControl
                                    autoFocus
                                    type="text"
                                    name="name"
                                    required
                                    value={this.state.city}
                                    onChange={(evt) => {
                                        this.updateValue('city', evt);
                                    }}
                                />
                            </FormGroup>
                            {this.props.googleMapsApiError && (
                                <Panel bsStyle="danger">
                                    <Panel.Heading>
                                        <Panel.Title>
                                            {Translate(this.props.googleMapsApiError)}
                                        </Panel.Title>
                                    </Panel.Heading>
                                </Panel>
                            )}
                        </fieldset>

                        <fieldset>
                            <FormGroup>
                                <ControlLabel>
                                    {Translate('photographers/overview/label/customer')}
                                </ControlLabel>
                                <FormSelect
                                    name="filter"
                                    value={this.state.typeFilter}
                                    onChange={(evt: any) => {
                                        this.setState({
                                            selectedBrokerFirmId: evt.target.value
                                        });
                                    }}
                                >
                                    <option value="-1" />
                                    {this.props.customers &&
                                        this.props.customers.map((customer: any) => {
                                            return (
                                                <option key={customer.id} value={customer.id}>
                                                    {customer.name}
                                                </option>
                                            );
                                        })}
                                </FormSelect>
                            </FormGroup>
                        </fieldset>

                        <fieldset>
                            <FormGroup>
                                <ControlLabel>
                                    {Translate('photographers/overview/label/products')}
                                </ControlLabel>
                                <FormSelect
                                    name="filter"
                                    value={this.state.typeFilter}
                                    onChange={(evt: any) => {
                                        this.setState({
                                            selectedProductId: evt.target.value
                                        });
                                    }}
                                >
                                    <option value="-1" />
                                    {this.props.products &&
                                        this.props.products.map((product: any) => {
                                            return (
                                                <option key={product.id} value={product.id}>
                                                    {product.name}
                                                </option>
                                            );
                                        })}
                                </FormSelect>
                            </FormGroup>
                        </fieldset>
                        <FormGroup>
                            <div className="pull-right">
                                <Button
                                    className="btn btn-primary"
                                    onClick={() => {
                                        this.getPhotographerOverview();
                                    }}
                                >
                                    {Translate('photographers/overview/button/search')}
                                </Button>
                                <Button
                                    onClick={() => {
                                        this.setState({
                                            streetAddress: '',
                                            postalCode: '',
                                            city: ''
                                        });
                                    }}
                                >
                                    {Translate('photographers/overview/button/clear')}
                                </Button>
                            </div>
                        </FormGroup>
                    </Col>

                    <Col md={7}>
                        {this.state.mapSettings.length > 0 && (
                            <Map
                                center={this.getMapCenter()}
                                settings={this.state.mapSettings
                                    .filter((x) => {
                                        return (
                                            !x.isPhotographer ||
                                            (this.filterFunc(x) && x.selectable)
                                        );
                                    })
                                    .map((photograper) => {
                                        var newPhotographer = Object.assign({}, photograper);
                                        newPhotographer.entityId = newPhotographer.photographerId;
                                        return newPhotographer;
                                    })}
                                highlightPhotographer={this.state.highlightedPhotographer}
                                preventRerendering={true}
                                areaSelected={(photographerId) =>
                                    this.highlightPhotographer(photographerId)
                                }
                            />
                        )}
                        {this.state.mapSettings.length === 0 && (
                            <h1>
                                {Translate(
                                    'photographers/overview/text/no-available-photographers'
                                )}
                            </h1>
                        )}
                    </Col>

                    <Col md={2}>
                        {this.state.mapSettings.length > 0 && (
                            <fieldset>
                                <legend>
                                    {Translate('photographers/overview/label/photographers')}
                                </legend>
                                <FormGroup>
                                    {this.state.mapSettings.length > 0 &&
                                        this.state.mapSettings
                                            .filter((x) => {
                                                return (
                                                    x.isPhotographer &&
                                                    this.filterFunc(x) &&
                                                    x.selectable
                                                );
                                            })
                                            .map((map: any, index: number) => {
                                                return (
                                                    <div
                                                        key={index}
                                                        className={
                                                            map.photographerId ===
                                                            this.state.highlightedPhotographer
                                                                ? 'selected-photographer'
                                                                : ''
                                                        }
                                                    >
                                                        {map.photographerId ===
                                                            this.state.highlightedPhotographer && (
                                                            <i className="material-icons">
                                                                chevron_right
                                                            </i>
                                                        )}
                                                        <a
                                                            role="button"
                                                            onClick={() => {
                                                                this.highlightPhotographer(
                                                                    map.photographerId
                                                                );
                                                            }}
                                                        >
                                                            {map.photographerName}
                                                        </a>
                                                    </div>
                                                );
                                            })}
                                </FormGroup>
                            </fieldset>
                        )}
                    </Col>
                </Row>
            </div>
        );
    }
}
function mapStateToProps(state: any, ownProps: any) {
    return {
        mapSettings: state.photographerOverview.photographerMapSettings,
        products: state.photographerOverview.products,
        customers: state.photographerOverview.customers,
        streetCoordinate: state.photographerOverview.streetCoordinate,
        googleMapsApiError: state.photographerOverview.googleMapsApiError,
        site: state.site
    };
}

function mapDispatchToProps(dispatch: any) {
    return {
        actions: {
            getPhotographerOverview: (
                year: any,
                month: any,
                day: any,
                streetAddress: any,
                postalCode: any,
                city: any,
                userSite: number
            ) =>
                dispatch(
                    Actions.getPhotographerOverview(
                        year,
                        month,
                        day,
                        streetAddress,
                        postalCode,
                        city,
                        userSite
                    )
                )
        }
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(PhotographerOverviewComponent);
